"use client";

import { useReviewerAccess } from "@/components/report/useReviewerAccess";
import VerdictSection from "@/app/assignments/[id]/components/DataTable/StudentDrawerContent/tabs/ReportTab/components/VerdictSection";

interface ReportVerdictGateProps {
  /** Попытка студента, по которой проктор выносит заключение */
  attemptId: number;
}

/**
 * Показывает модуль «Честно / Не честно» (тот же VerdictSection, что в дравере
 * студента: те же эндпоинты /api/assignment-reviewer-reports, список
 * комментариев, история заключений) только авторизованному проктору.
 *
 * На публичном /report redux-слайс auth обнуляется, поэтому роль читаем
 * напрямую через useGetUserQuery (поднят в Providers, токен — из localStorage).
 */
export default function ReportVerdictGate({ attemptId }: ReportVerdictGateProps) {
  const { canReview } = useReviewerAccess();

  if (!canReview) return null;

  return <VerdictSection attemptId={attemptId} />;
}
